var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M85.422,16V8.711h2.489l.356-2.844H85.422V4.089c0-.8.267-1.422,1.422-1.422h1.511V.089C88,.089,87.111,0,86.133,0a3.431,3.431,0,0,0-3.644,3.733V5.867H80V8.711h2.489V16Z","transform":"translate(-80)","fill":"inherit","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"width":"8.356","height":"16","viewBox":"0 0 8.356 16"};

module.exports = Facebook;

Facebook.default = Facebook;
